<div [ngClass]="{ 'dummy-background': showContent, 'dummy-background-hide': !showContent }" (click)="panelToggle('close')"></div>
<div class="panel-container product-customizer">
	<div class="pdp-sidenav-content" #sidePanel [ngClass]="{ 'pdp-sidenav-show': showContent, 'pdp-sidenav-content-left':side==='left', 'pdp-sidenav-content-right':side==='right', 'zip-confirm-width': zipConfirm }" [attr.aria-hidden]="!showContent ? 'true' : 'false'">
		<div class="panel-description-content" [ngClass]="panelContainerClass">
			<div class="fixed-header" [ngClass]="{ 'flex-row right-side-panel': side==='right', 'flex-row-reverse left-side-panel': side==='left' }">
				<div class="side-nav-title">
					<ng-content select="myCustomHeader"></ng-content>
				</div>
				<button
					type="button"
					class="btn btn-close"
					aria-label="close"
					data-cy="common-side-nav-back-btn"
					(click)="panelToggle('close')">
						<homefield-icon
							class="hmf-header-xs-xs hmf-header-m-m hover-pointer"
							name="sign-cancel"
							aria-hidden="true">
						</homefield-icon>
					</button>
			</div>
			<div [ngClass]="panelBodyClass">
				<ng-content select="myCustomBody"></ng-content>
			</div>
		</div>
	</div>
	<div class="overflow-hidden" *ngIf="isFormEmpty">
		<div class="hmf-display-flex hmf-flex-wrap hmf-mx-0 service-section">
			<!-- Customizer Button-->
			<div class="wrapper-button">
				<span [ngClass]="{'hmf-display-flex' : addFlexBox, 'd-inline-block' : !addFlexBox}" (click)="sidePanel.scrollTop=0; panelToggle('open')"><ng-content select="myPanelCover"></ng-content></span>
			</div>
		</div>
	</div>
</div>

